import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaCalendarDay } from "react-icons/fa6";
import Rewards from "./index";
import ViewHoliday from "./view";
import EditAward from "./edit";

import { MODULE_REWARDS } from "variables/modules";

const rewardsRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Rewards",
		basePath: "rewards",
		mainComponent: <Rewards />,
	    layout: "/console",	   
	    icon: <FaCalendarDay className="icon-item" />,
	    subTitle:"rewards",
	    createComponent: <EditAward />,
	    editComponent: <EditAward />,
		level:5,
		moduleId: MODULE_REWARDS,
	})
]

export default rewardsRoutes;